import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 volumes', '5 bonus', '240 pages', '8 à 15 ans'];
const reassurances = ['Téléchargement immédiat', 'PDF à imprimer', 'Garantie satisfaction 7 jours'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15ckl4zoj0ke2">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbty7qhfqydt" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxvrvodzf0d">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1wsrv47gke9">
          Vos séances de technologie peuvent être <em className="text-red-700" data-id="element-118" data-mp="1o67ojeh8qfbm">prêtes dès aujourd'hui.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="223w7ggrqzce1">
          Au lieu de chercher des projets, de créer chaque fiche vous-même et de passer vos dimanches soirs à préparer, vous avez un système organisé pour toute l'année. Plus de temps pour ce qui compte vraiment :
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s6ikp9p7h8lj">
          Vos élèves. Votre enseignement. Votre vie en dehors de l'école.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="1246hs6aaas6v">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b3a0381mn3kb">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1yy9drqs5vu">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fwcwrp1pat4q">Paiement unique, sans abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ksl62lt7vs3z">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1psze43utj220" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pqmnl2azvjdc">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3qu5q68v05ppm">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qsb2wnw9dlid" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}